import { combineReducers } from 'redux';
import postSaleReducer from '../Header/Account/PostSale/ducks';
import header from '../Header/ducks/reducers';
import ui from './middleware/screenResize';
import accountModal from '../Header/Modals/AccountModal/ducks/reducers';
import userNotifications from '../Header/UserNotifications/ducks';
import outageBannerReducer from '../Header/Banners/OutageBanner/ducks';
import supportDropdownReducers from '../Header/SupportDropdown/ducks';

const {
  faqReducer,
  videoReducer,
  contentServiceRequestIdReducer,
  isSupportMenuOpenReducer,
  isSupportContentLoading,
  isMobileSupportMenuOpenReducer,
  focusedVideoIdReducer,
  supportHoursReducer,
} = supportDropdownReducers;

export default combineReducers({
  postSale: postSaleReducer,
  outageBanner: outageBannerReducer,
  header,
  ui,
  faqs: faqReducer,
  videos: videoReducer,
  contentServiceRequestId: contentServiceRequestIdReducer,
  isSupportMenuOpen: isSupportMenuOpenReducer,
  isSupportContentLoading,
  isMobileSupportMenuOpen: isMobileSupportMenuOpenReducer,
  supportHours: supportHoursReducer,
  accountModal,
  userNotifications,
  focusedVideoId: focusedVideoIdReducer,
});
